module.exports = __webpack_public_path__ + "img/img-3.4f39f932.png";